var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { PureComponent } from 'react';
import { defaults } from 'lodash';
import { Select } from '../select';
import { globalConfig } from '@comall-backend-builder/core';
import { services } from '@comall-backend-builder/core';
var DEFAULT_STYLE = {
  width: '120px',
  zIndex: 3,
  marginRight: '15px',
  msFlex: '0 0 auto',
  flex: '0 0 auto'
};

var LanguageSelect = function (_super) {
  __extends(LanguageSelect, _super);

  function LanguageSelect() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  LanguageSelect.prototype.render = function () {
    var _a = this.props,
        options = _a.options,
        placeholder = _a.placeholder,
        style = _a.style,
        className = _a.className;
    var props = {
      name: 'language',
      value: services.language.getCurrentLanguage().id,
      options: options || globalConfig.get('language.availableLanguages') || [],
      placeholder: placeholder || services.language.getText('common.pleaseSelect'),
      style: defaults(style, DEFAULT_STYLE),
      className: className,
      onChange: services.language.changeTo
    };
    return React.createElement(Select, __assign({}, props));
  };

  return LanguageSelect;
}(PureComponent);

export { LanguageSelect };